var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzBox,{ref:"popover",style:(_setup.floatingStyles),attrs:{"dark-mode":_vm.darkMode,"color":_vm.color,"radius":_vm.radius}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }